/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScopeResourceGroup {
    getFixupPrototypeFunction() { return ScopeResourceGroup.fixupPrototype; }

    static newInstance(model: Partial<ScopeResourceGroup>): ScopeResourceGroup {
        let obj = Object.assign(new ScopeResourceGroup(), model);
        ScopeResourceGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScopeResourceGroup>): ScopeResourceGroup {
        if (!model) return null;
        return ScopeResourceGroup.newInstance(<ScopeResourceGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScopeResourceGroup) {
        if (!obj) return;

        models.ScopeResourceGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScopeResourceGroup): boolean {
        Object.setPrototypeOf(obj, ScopeResourceGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name for resource
     */
    name: string;

    /**
     * Id for resource
     */
    id: string;

}
